module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user"
  }, [_c('actionsheet', {
    staticClass: "text-l",
    attrs: {
      "menus": _vm.menus1,
      "show-cancel": ""
    },
    on: {
      "on-click-menu": _vm.click
    },
    model: {
      value: (_vm.show1),
      callback: function($$v) {
        _vm.show1 = $$v
      },
      expression: "show1"
    }
  }), _vm._v(" "), _c('group', {
    staticClass: "user-group"
  }, [_c('cell', {
    attrs: {
      "title": "邀请得大礼",
      "link": "/userCenter/invite",
      "is-link": ""
    }
  }, [_c('img', {
    staticStyle: {
      "display": "block",
      "margin-right": "10px"
    },
    attrs: {
      "slot": "icon",
      "width": "14",
      "src": require("./images/6.jpg")
    },
    slot: "icon"
  })]), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "我的收藏",
      "link": "/userCenter/collectList",
      "is-link": ""
    }
  }, [_c('img', {
    staticStyle: {
      "display": "block",
      "margin-right": "10px"
    },
    attrs: {
      "slot": "icon",
      "width": "14",
      "src": require("./images/7.jpg")
    },
    slot: "icon"
  })]), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "我的优惠券",
      "link": "/userCenter/couponList",
      "is-link": ""
    }
  }, [_c('img', {
    staticStyle: {
      "display": "block",
      "margin-right": "10px"
    },
    attrs: {
      "slot": "icon",
      "width": "14",
      "src": require("./images/5.jpg")
    },
    slot: "icon"
  })]), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "物流跟踪",
      "link": "/userCenter/shipment",
      "is-link": ""
    }
  }, [_c('img', {
    staticStyle: {
      "display": "block",
      "margin-right": "10px"
    },
    attrs: {
      "slot": "icon",
      "width": "14",
      "src": require("./images/2.jpg")
    },
    slot: "icon"
  })]), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "收货地址",
      "link": "/shippingAddress",
      "is-link": ""
    }
  }, [_c('img', {
    staticStyle: {
      "display": "block",
      "margin-right": "10px"
    },
    attrs: {
      "slot": "icon",
      "width": "14",
      "src": require("./images/4.jpg")
    },
    slot: "icon"
  })]), _vm._v(" "), (!_vm.userInfo.mobileNumber) ? _c('cell', {
    attrs: {
      "title": "绑定手机",
      "link": "/userCenter/bindMobileNumber",
      "is-link": ""
    }
  }, [_c('img', {
    staticStyle: {
      "display": "block",
      "margin-right": "10px"
    },
    attrs: {
      "slot": "icon",
      "width": "14",
      "src": require("./images/8.jpg")
    },
    slot: "icon"
  })]) : _vm._e(), _vm._v(" "), (_vm.shopInfo.servicePhoneNumber) ? _c('cell', {
    attrs: {
      "title": "客服电话"
    }
  }, [_c('img', {
    staticStyle: {
      "display": "block",
      "margin-right": "10px"
    },
    attrs: {
      "slot": "icon",
      "width": "14",
      "src": require("./images/9.jpg")
    },
    slot: "icon"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": 'tel:' + _vm.shopInfo.servicePhoneNumber
    }
  }, [_vm._v(_vm._s(_vm.shopInfo.servicePhoneNumber))])]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fd6f8f8"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserCenter/BtmNav.vue
// module id = 543
// module chunks = 0